export const useGroupSchools = (clusters) => {
  if (!clusters) return [];

  const schoolClusters = clusters
    .filter((cluster) => cluster.level_name !== null)
    .reduce((acc, { id, level_name }) => {
      const existingCluster = acc.find((c) => c.name === level_name);
      if (existingCluster) {
        existingCluster.ids.push(id);
      } else {
        acc.push({
          ids: [id],
          is_school: true,
          name: level_name,
        });
      }
      return acc;
    }, []);

  const nonSchoolClusters = clusters
    .filter((cluster) => cluster.level_name === null)
    .map(({ id, name }) => ({ ids: [id], name, is_school: false }));

  return [...schoolClusters, ...nonSchoolClusters];
};
